export default __webpack_public_path__ + "static/media/Brends.593bbc82.png";